import { useEffect } from "react";

import { useStore } from "@/store";
import { useDirectChats } from "@/store/useDirectChats";
import { useTeamChats } from "@/store/useTeamChats";

export function useSidebarUnreadCounts() {
  const { auth, teams } = useStore();
  const teamChats = useTeamChats();
  const directChats = useDirectChats();
  const team = teams.currentTeam;
  const currentUserUid = auth.currentUser?.uid;

  useEffect(() => {
    if (teamChats.isAvailable && teamChats.status === "idle") void teamChats.fetchChats();
  }, [teamChats, teamChats.isAvailable, teamChats.status, teamChats.team]);

  useEffect(() => {
    if (directChats.status === "idle") void directChats.fetchChats();
  }, [currentUserUid, directChats, directChats.status]);

  const isReady = !teamChats.isAvailable || teamChats.status === "loaded";
  const channelsUnread = teamChats.unreadMessagesCount + directChats.unreadMessagesCount;
  // The team unread count excludes direct chats server side.
  const docsUnread = isReady
    ? Math.max(0, (team?.unreadMessagesCount ?? 0) - teamChats.unreadMessagesCount)
    : 0;

  return { docsUnread, channelsUnread };
}
